import { skipToken, useQuery } from '@apollo/client/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CHAT_VIEW_STATES, useCurrentChat, ChatAPI } from '@guuru/chat-web';
import { parse } from '@guuru/url-common';
import GET_QUICK_QUESTIONS from './queries/GetQuickQuestions';
import QuestionButton from './QuestionButton';
import QuestionsList from './QuestionsList';

const viewStatesWhereShouldAppear = [CHAT_VIEW_STATES.question];

const ChatQuickQuestions = function () {
  const { viewState } = useCurrentChat();
  const { partnerId } = useParams();
  const { chatAutoMessageId } = parse(window.location.search);
  const locale = ChatAPI.storeRetrieveLocaleParameter();
  const {
    data: { partner: { quickQuestions: { questions = [] } = {} } = {} } = {},
    loading,
  } = useQuery(
    GET_QUICK_QUESTIONS,
    chatAutoMessageId && viewStatesWhereShouldAppear.includes(viewState)
      ? {
          variables: {
            locale,
            id: partnerId,
            autoMessageId: chatAutoMessageId,
          },
        }
      : skipToken,
  );

  if (
    loading
    || questions?.length < 1
    || !viewStatesWhereShouldAppear.includes(viewState)
  ) {
    return null;
  }

  return (
    <QuestionsList>
      {questions?.map((question) => (
        <QuestionButton key={question} question={question} />
      ))}
    </QuestionsList>
  );
};

export default ChatQuickQuestions;
